export default abstract class Model {
  public id: number = 0;

  public fetched_at: Date | null = null;
  public options: Record<string, never | null> = {};
}
